import { render, staticRenderFns } from "./SelectMultipleAdmins.vue?vue&type=template&id=12fc191e&"
import script from "./SelectMultipleAdmins.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleAdmins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports